/* eslint-disable  react/no-multi-comp */
/*  eslint-disable react/display-name */
/*  eslint-disable react/prop-types */

import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import connect from '../utils/connect';

import { Card, Row, Col, Flex } from '@app/ui';

import { NavLink, Navigate, useLocation } from 'react-router-dom';

import Onboarding from './Onboarding';
import ViewConfig from './ViewConfig';

import SocialAccounts from './SocialAccounts';

import './Onboarding.scss';
import './bulkSponsors.scss';
import {
    AUDIENCE_INSIGHTS,
    HOME_PAGE,
    INSIGHT_PAGE,
    SOCIAL_MEDIA_POST_PAGE,
    TEXT_TRACKING,
} from '../constants/config';
import TextTracking from './text-tracking/TextTracking';
import classNames from '@app/ui/sports-components/utils/classNames';

const ClientSettings = ({ client, user }) => {
    const { t } = useTranslation('settings');
    const configStatusId = client ? client.configStatusId : null;
    const canAccessTextTracking = useMemo(
        () => client.permissions.includes(TEXT_TRACKING),
        [client],
    );

    const canAccessViewConfiguration = [
        HOME_PAGE,
        INSIGHT_PAGE,
        SOCIAL_MEDIA_POST_PAGE,
    ].some(pagePermission => client.permissions.includes(pagePermission));

    const canAccessLinkedSocialAccounts =
        canAccessViewConfiguration ||
        client.permissions.includes(AUDIENCE_INSIGHTS);

    const canAccessOnboarding = Boolean(configStatusId);
    const { isLoggedIn } = user;
    const location = useLocation();

    const path = location.pathname.split('/').pop();

    const page = useMemo(() => {
        if (path === 'current-configuration') return <ViewConfig />;
        if (path === 'onboarding') return <Onboarding />;
        if (path === 'text-tracking') return <TextTracking />;
        if (path === 'linked-social-accounts') return <SocialAccounts />;
        return (
            <Navigate
                to={
                    canAccessOnboarding
                        ? `/c/${client.id}/client-configuration/onboarding`
                        : `/c/${client.id}/client-configuration/current-configuration`
                }
            />
        );
    }, [path]);

    return (
        <Flex vertical className="gds-layout__container -z-7">
            <Row gutter={16}>
                <Col md={24} className="-p-t-4 -p-t-2-sm -m-b-3">
                    <div className="gds-flex gds-flex--align-center">
                        <h1 className="gds-text--header-md">
                            {t('clientConfiguration.title')}
                        </h1>
                    </div>
                </Col>
                <Col md={24}>
                    <section>
                        <nav>
                            <ul className="gds-nav-tabs gds-nav-tabs--underline-secondary gds-nav-tabs--underline gds-nav-tabs--no-resp">
                                {canAccessOnboarding && (
                                    <NavLink
                                        className={({ isActive }) =>
                                            classNames(
                                                'gds-nav-tabs__list-item',
                                                'gds-nav-tabs__list-item--underline',
                                                {
                                                    'gds-nav-tabs__list-item--active':
                                                        isActive,
                                                },
                                            )
                                        }
                                        to={`/c/${client.id}/client-configuration/onboarding`}
                                    >
                                        <span className="gds-nav-tabs__link gds-nav-tabs__link--underline">
                                            {t(
                                                'clientConfiguration.tabs.onboarding',
                                            )}
                                        </span>
                                    </NavLink>
                                )}
                                {canAccessTextTracking && (
                                    <NavLink
                                        data-test="text-tracking-tab"
                                        className={({ isActive }) =>
                                            classNames(
                                                'gds-nav-tabs__list-item',
                                                'gds-nav-tabs__list-item--underline',
                                                {
                                                    'gds-nav-tabs__list-item--active':
                                                        isActive,
                                                },
                                            )
                                        }
                                        to={`/c/${client.id}/client-configuration/text-tracking`}
                                    >
                                        <span className="gds-nav-tabs__link gds-nav-tabs__link--underline">
                                            {t(
                                                'clientConfiguration.tabs.textTracking',
                                            )}
                                        </span>
                                    </NavLink>
                                )}

                                {canAccessViewConfiguration && (
                                    <NavLink
                                        className={({ isActive }) =>
                                            classNames(
                                                'gds-nav-tabs__list-item',
                                                'gds-nav-tabs__list-item--underline',
                                                {
                                                    'gds-nav-tabs__list-item--active':
                                                        isActive,
                                                },
                                            )
                                        }
                                        to={`/c/${client.id}/client-configuration/current-configuration`}
                                    >
                                        <span className="gds-nav-tabs__link gds-nav-tabs__link--underline">
                                            {t(
                                                'clientConfiguration.tabs.viewConfiguration',
                                            )}
                                        </span>
                                    </NavLink>
                                )}

                                {canAccessLinkedSocialAccounts && (
                                    <NavLink
                                        className={({ isActive }) =>
                                            classNames(
                                                'gds-nav-tabs__list-item',
                                                'gds-nav-tabs__list-item--underline',
                                                {
                                                    'gds-nav-tabs__list-item--active':
                                                        isActive,
                                                },
                                            )
                                        }
                                        to={`/c/${client.id}/client-configuration/linked-social-accounts`}
                                    >
                                        <span className="gds-nav-tabs__link  gds-nav-tabs__link--dark gds-nav-tabs__link--underline">
                                            {t(
                                                'clientConfiguration.tabs.linkedSocialAccounts',
                                            )}
                                        </span>
                                    </NavLink>
                                )}
                            </ul>
                        </nav>
                    </section>
                </Col>
                <Col md={24}>
                    <Card styles={{ body: { padding: 0 } }}>
                        <div className="gds-card__block -p-a-3 -color-bg-lt-1">
                            {isLoggedIn && page}
                        </div>
                    </Card>
                </Col>
            </Row>
        </Flex>
    );
};

ClientSettings.propTypes = {
    client: PropTypes.object,
    user: PropTypes.object,
};

export default connect(['client', 'user'])(ClientSettings);
